"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _redux = require("redux");
var _angieslistAppPlatform = require("angieslist-app-platform");
var _cookieUtils = require("angieslist-app-platform/lib/common/utils/cookieUtils");
var myAccountUIActions = _interopRequireWildcard(require("../actions/myAccountUIActions"));
var contactPreferencesActions = _interopRequireWildcard(require("../actions/contactPreferencesActions"));
var authActions = _interopRequireWildcard(require("angieslist-app-platform/lib/common/auth/authActions"));
var _memberMgmtGatewayActionKeys = _interopRequireDefault(require("../constants/memberMgmtGatewayActionKeys"));
var _immutable = require("immutable");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = exports["default"] = (0, _redux.combineReducers)({
  fetchUser: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].FETCH_USER, {
    'REMOVE_ADDRESS': function REMOVE_ADDRESS(state, action) {
      var updatedState = state.updateIn(['response', 'addresses'], function (addresses) {
        return addresses.filter(function (address) {
          return address.get('userAddressId') !== action.payload.userAddressId;
        });
      });
      return state.merge(updatedState);
    },
    'MAKE_PRIMARY_ADDRESS': function MAKE_PRIMARY_ADDRESS(state, action) {
      var updatedState = state.updateIn(['response', 'addresses'], function (userAddresses) {
        return userAddresses.map(function (address) {
          if (address.get('isPrimary')) {
            return address.set('isPrimary', false);
          } else if (address.get('userAddressId') === action.payload.userAddressId) {
            return address.set('isPrimary', true);
          } else {
            return address;
          }
        });
      });
      return state.merge(updatedState);
    },
    'UPDATE_PERSONAL_DETAILS': function UPDATE_PERSONAL_DETAILS(state, action) {
      var updatedPersonalDetails = state.updateIn(['response'], function (response) {
        var primaryContactInfo = response.get('primaryContactInformation');
        // eslint-disable-next-line
        var primaryContact = !primaryContactInfo ? (0, _immutable.Map)() : primaryContactInfo;
        var updatedPrimaryContact = primaryContact.merge({
          'primaryPhoneNumber': action.payload.contactInformation.primaryPhoneNumber,
          'mobilePhoneNumber': action.payload.contactInformation.mobilePhoneNumber
        });
        var setPersonalDetails = response.set('lastName', action.payload.lastName).set('firstName', action.payload.firstName).set('primaryContactInformation', updatedPrimaryContact);
        return setPersonalDetails;
      });
      return state.merge(updatedPersonalDetails);
    },
    'REFETCH_USER_SUCCESS': function REFETCH_USER_SUCCESS(state, action) {
      var newState = {
        response: action.payload.body
      };
      return state.merge(newState);
    }
  }),
  updateUser: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].UPDATE_USER),
  deleteUserAddress: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].DELETE_USER_ADDRESS, (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _memberMgmtGatewayActionKeys["default"].DELETE_USER_ADDRESS_START, function (state, action) {
    action.addSideEffect(function (store) {
      store.dispatch({
        type: _memberMgmtGatewayActionKeys["default"].SET_PRIMARY_ADDRESS_RESET
      });
    });
    return _angieslistAppPlatform.AsyncRequest.setStart(state, action.payload);
  }), _memberMgmtGatewayActionKeys["default"].DELETE_USER_ADDRESS_SUCCESS, function (state, action) {
    var currentState = state.toJS();
    var _currentState$request = currentState.request,
      userAddressId = _currentState$request.userAddressId,
      addressId = _currentState$request.addressId;
    action.addSideEffect(function (store) {
      store.dispatch(myAccountUIActions.deleteAddress(userAddressId, addressId));
    });
    return _angieslistAppPlatform.AsyncRequest.setSuccess(state, action.payload.body);
  })),
  setPrimaryAddress: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].SET_PRIMARY_ADDRESS, (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _memberMgmtGatewayActionKeys["default"].SET_PRIMARY_ADDRESS_START, function (state, action) {
    action.addSideEffect(function (store) {
      store.dispatch({
        type: _memberMgmtGatewayActionKeys["default"].DELETE_USER_ADDRESS_RESET
      });
    });
    return _angieslistAppPlatform.AsyncRequest.setStart(state, action.payload);
  }), _memberMgmtGatewayActionKeys["default"].SET_PRIMARY_ADDRESS_SUCCESS, function (state, action) {
    var currentState = state.toJS();
    var _currentState$request2 = currentState.request,
      userAddressId = _currentState$request2.userAddressId,
      addressId = _currentState$request2.addressId;
    action.addSideEffect(function (store) {
      var user = (0, _get2["default"])(store.getState(), 'user');
      var addresses = (0, _get2["default"])(user, 'userInfo.response._embedded.userAddresses');
      var address = (0, _find2["default"])(addresses, {
        'addressId': "".concat(addressId)
      });
      store.dispatch(myAccountUIActions.changeCurrentAddress(user, address));
      store.dispatch(myAccountUIActions.makePrimary(userAddressId, addressId));
    });
    return _angieslistAppPlatform.AsyncRequest.setSuccess(state, action.payload.body);
  })),
  changePassword: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].CHANGE_PASSWORD, (0, _defineProperty2["default"])({}, _memberMgmtGatewayActionKeys["default"].CHANGE_PASSWORD_SUCCESS, function (state, action) {
    action.addSideEffect(function (store) {
      (0, _cookieUtils.setCookie)('r', '/app/account');
      var storeState = store.getState();
      var identifier = (0, _get2["default"])(storeState, 'user.userInfo.response.email');
      var token = (0, _get2["default"])(storeState, 'memberManagementGateway.changePassword.request.newPassword');
      if (!!identifier && !!token) {
        store.dispatch(authActions.login(identifier, token));
      }
    });
    return _angieslistAppPlatform.AsyncRequest.setSuccess(state, action.payload);
  })),
  addAddress: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].ADD_ADDRESS),
  getContactPreferences: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].GET_USER_CONTACT_PREFERENCES, {
    'UPDATE_USER_CONTACT_PREF_STATE': function UPDATE_USER_CONTACT_PREF_STATE(state, action) {
      var updatedState = state.updateIn(['response', 'preferences'], function (preferences) {
        return preferences.map(function (pref) {
          var currentPref = (0, _find2["default"])(action.payload, {
            'key': pref.get('key')
          });
          return pref.set('enabled', currentPref.enabled);
        });
      });
      return state.merge(updatedState);
    }
  }),
  saveContactPreferences: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].SAVE_USER_CONTACT_PREFERENCES, (0, _defineProperty2["default"])({}, _memberMgmtGatewayActionKeys["default"].SAVE_USER_CONTACT_PREFERENCES_SUCCESS, function (state, action) {
    var currentState = state.toJS();
    var preferences = currentState.request.params.preferences;
    action.addSideEffect(function (store) {
      store.dispatch(myAccountUIActions.updateUserContactPrefState(preferences));
    });
    return _angieslistAppPlatform.AsyncRequest.setSuccess(state, action.payload);
  })),
  getMembershipInformation: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].GET_MEMBERSHIP_INFORMATION),
  getEligibleForRefund: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].GET_ELIGIBLE_FOR_REFUND),
  cancelAutoRenew: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].CANCEL_AUTO_RENEW),
  getContactPreferencesByEmail: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].GET_USER_CONTACT_PREFERENCES_BY_EMAIL, {
    'UPDATE_USER_CONTACT_PREF_STATE_BY_EMAIL': function UPDATE_USER_CONTACT_PREF_STATE_BY_EMAIL(state, action) {
      var updatedState = state.updateIn(['response', 'preferences'], function (preferences) {
        return preferences.map(function (pref) {
          var currentPref = (0, _find2["default"])(action.payload, {
            'key': pref.get('key')
          });
          if (currentPref) {
            return pref.set('enabled', currentPref.enabled);
          } else {
            return pref;
          }
        });
      });
      return state.merge(updatedState);
    }
  }),
  unsubscribeFromContactPreferenceByEmail: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].UNSUBSCRIBE_FROM_USER_CONTACT_PREFERENCE_BY_EMAIL, (0, _defineProperty2["default"])({}, _memberMgmtGatewayActionKeys["default"].UNSUBSCRIBE_FROM_USER_CONTACT_PREFERENCE_BY_EMAIL_SUCCESS, function (state, action) {
    var currentState = state.toJS();
    var preferences = currentState.request.params.preferences;
    action.addSideEffect(function (store) {
      store.dispatch(contactPreferencesActions.updateUserContactPrefStateByEmail(preferences));
    });
    return _angieslistAppPlatform.AsyncRequest.setSuccess(state, action.payload);
  })),
  saveContactPreferencesByEmail: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].SAVE_USER_CONTACT_PREFERENCES_BY_EMAIL, (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _memberMgmtGatewayActionKeys["default"].SAVE_USER_CONTACT_PREFERENCES_BY_EMAIL_START, function (state, action) {
    action.addSideEffect(function (store) {
      store.dispatch({
        type: _memberMgmtGatewayActionKeys["default"].UNSUBSCRIBE_FROM_USER_CONTACT_PREFERENCE_BY_EMAIL_RESET
      });
    });
    return _angieslistAppPlatform.AsyncRequest.setStart(state, action.payload);
  }), _memberMgmtGatewayActionKeys["default"].SAVE_USER_CONTACT_PREFERENCES_BY_EMAIL_SUCCESS, function (state, action) {
    var currentState = state.toJS();
    var preferences = currentState.request.params.preferences;
    action.addSideEffect(function (store) {
      store.dispatch(contactPreferencesActions.updateUserContactPrefStateByEmail(preferences));
    });
    return _angieslistAppPlatform.AsyncRequest.setSuccess(state, action.payload);
  })),
  submitPrivacyRequest: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].SUBMIT_PRIVACY_REQUEST, (0, _defineProperty2["default"])({}, _memberMgmtGatewayActionKeys["default"].SUBMIT_PRIVACY_REQUEST_SUCCESS, function (state) {
    return _objectSpread(_objectSpread({}, state.toJSON()), {}, {
      isLoading: false,
      response: {
        success: true
      }
    });
  })),
  verifyPrivacyRequest: _angieslistAppPlatform.AsyncRequest.createReducer(_memberMgmtGatewayActionKeys["default"].VERIFY_PRIVACY_REQUEST)
});
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/reducers/memberMgmtGatewayReducer.js
// module id = 4399
// module chunks = 9